import Anchor from 'components/typography/anchor';
import { PAYMENT_METHOD_PAYMENT_TYPES } from 'utilities/stripe/config';
import CardSylization from './CardStylization';

const CardDisplay = ({ paymentMethod, billingPortalSession }) => {
  return (
    <div className="card-flat">
      <CardSylization
        brand={paymentMethod.brand}
        last4={paymentMethod.last4}
        expMonth={paymentMethod.expMonth}
        expYear={paymentMethod.expYear}
      />
      <Anchor
        className="anchor-subtle self-end text-sm"
        href={billingPortalSession}
      >
        Change payment method
      </Anchor>
    </div>
  );
};

const BankAccountDisplay = ({ paymentMethod }) => {
  return <p>Your bank account ending in {paymentMethod.last4} is connected.</p>;
};

const LinkDisplay = ({ paymentMethod }) => {
  return (
    <p>
      Your Stripe Link account with email address {paymentMethod.email} is
      connected.
    </p>
  );
};

const CashAppDisplay = () => {
  return <p>Your Cash App account is connected.</p>;
};

const AmazonPayDisplay = ({ billingPortalSession }) => {
  return (
    <div className="card-flat">
      <div className="flex grow flex-wrap items-center gap-4">
        <CardSylization brand="amazon_pay" />
      </div>
      <Anchor
        className="anchor-subtle self-end text-sm"
        href={billingPortalSession}
      >
        Change payment method
      </Anchor>
    </div>
  );
};

const NoPaymentMethodDisplay = () => {
  return <p>You have no active payment on file.</p>;
};

const ExistingPaymentMethodDisplay = ({
  paymentMethod,
  billingPortalSession,
}) => {
  let paymentMethodElement;

  if (!paymentMethod) {
    paymentMethodElement = (
      <NoPaymentMethodDisplay billingPortalSession={billingPortalSession} />
    );
  } else if (paymentMethod.type === PAYMENT_METHOD_PAYMENT_TYPES.CARD) {
    paymentMethodElement = (
      <CardDisplay
        paymentMethod={paymentMethod}
        billingPortalSession={billingPortalSession}
      />
    );
  } else if (
    paymentMethod.type === PAYMENT_METHOD_PAYMENT_TYPES.US_BANK_ACCOUNT
  ) {
    paymentMethodElement = (
      <BankAccountDisplay
        paymentMethod={paymentMethod}
        billingPortalSession={billingPortalSession}
      />
    );
  } else if (paymentMethod.type === PAYMENT_METHOD_PAYMENT_TYPES.LINK) {
    paymentMethodElement = (
      <LinkDisplay
        paymentMethod={paymentMethod}
        billingPortalSession={billingPortalSession}
      />
    );
  } else if (paymentMethod.type === PAYMENT_METHOD_PAYMENT_TYPES.CASH_APP) {
    paymentMethodElement = (
      <CashAppDisplay
        paymentMethod={paymentMethod}
        billingPortalSession={billingPortalSession}
      />
    );
  } else if (paymentMethod.type === PAYMENT_METHOD_PAYMENT_TYPES.AMAZON_PAY) {
    paymentMethodElement = (
      <AmazonPayDisplay
        paymentMethod={paymentMethod}
        billingPortalSession={billingPortalSession}
      />
    );
  } else {
    paymentMethodElement = <p>Unknown payment method type</p>;
  }

  return paymentMethodElement;
};

export {
  BankAccountDisplay,
  CardDisplay,
  CashAppDisplay,
  ExistingPaymentMethodDisplay,
  LinkDisplay,
};
